let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2HlAY"), load("kB1sA"), load("jCu7l"), load("aZinD"), load("6qah4"), load("6Yu8N"), load("6iF9L")]).then(() => parcelRequire('hyBPw'));